export const isAltEnvironment = (): boolean => process.env.REACT_APP_ENV_SUFFIX === 'alt';
